import * as React from "react";

export function ConnectIcon(props) {
  return (
    <svg
      width="1em"
      height="1em"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M7.782 15.19c4.087 0 7.47-3.384 7.47-7.47 0-4.08-3.39-7.471-7.478-7.471-4.08 0-7.463 3.39-7.463 7.47 0 4.087 3.391 7.47 7.47 7.47zM2.896 9.147L5.438 5.86c.161-.19.315-.278.483-.278.132 0 .271.05.418.131L9.62 7.47l2.52-1.355c.446-.241.85.198.534.608l-2.556 3.303c-.154.198-.322.279-.49.279a.893.893 0 01-.41-.132l-3.29-1.758L3.432 9.77c-.432.234-.879-.168-.535-.623z"
        fill="currentColor"
      />
    </svg>
  );
}
